module.exports = __webpack_public_path__ + "static/media/G CLoud.cafdea6a.png";